import { render, staticRenderFns } from "./PdfModalDisplayComponent.vue?vue&type=template&id=65fdef7a&scoped=true"
import script from "./PdfModalDisplayComponent.vue?vue&type=script&lang=js"
export * from "./PdfModalDisplayComponent.vue?vue&type=script&lang=js"
import "./PdfModalDisplayComponent.vue?vue&type=style&index=0&id=65fdef7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fdef7a",
  null
  
)

export default component.exports